import React, { Component } from "react"
import {
  Button,
  Icon,
  Table,
  Row,
  Pagination,
  message,
  Select,
  Popover,
  Tooltip,
} from "antd"
import config from "app/config"
import downloadIcon from "app/styles/images/sp/download.svg"
import { observer, inject } from "mobx-react"
import PushModal from "./PushModal"
// import CnvRead from './CnvRead'
import CompareModal from "./CompareModal"
import EditTracerModal from "./EditTracerModal"
import cx from "classnames"
import { PREPARE_RUN, RUNNING } from "app/utils/const"
import pushIcon from "app/styles/images/sp/push.svg"
import ImageLightBox from "./ImageLightBox"
// import unscrambleImage from "app/styles/images/sp/unscramble.png"
import { observable, computed } from "mobx"
import "./Index.scss"
import warningIcon from "app/styles/images/sp/data-warning.svg"

const Option = Select.Option
const columnsReport = [
  {
    title: "chromosome",
    dataIndex: "chromosome",
    width: 150,
  },
  {
    title: "Average",
    dataIndex: "average",
    width: 150,
  },
  {
    title: "Aneuploidy",
    dataIndex: "aneuploidy",
  },
  {
    title: "position",
    dataIndex: "position",
  },
]

@inject("auth")
@observer
export default class ReportDetail extends Component {
  @observable resultAneu = "";
  @observable resultCNV = "";
  @observable resultGender = "";
  @observable dumplicateCnv = "";
  constructor(props) {
    super(props)
    this.state = {
      activeReportIndex: 0,
      currentPage: 1,
      reportListArr: [],
      pushModalShowed: false,
      exportModalShowed: false,
      editTracerShowed: false,
      compareModalShowed: false,
      syncBtnLoading: false,
      PointSplitCnvPngShow:false,
    }
  }

  showModal = (field) => {
    this.setState({
      [field]: true,
    })
  }

  closeModal = (field) => {
    this.setState({
      [field]: false,
    })
  }

  isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.index !== this.props.index) {
      this.initNav(nextProps.index)
    }
  }

  componentWillMount() {
    this.initNav(this.props.index)
  }

  componentDidMount() {
    const {
      index,
      data,
      auth: { userInfo },
    } = this.props
    if (userInfo.roleType !== "research") {
      const { getSummaries } = this.props.store
      const reportId =
        data.reportList[index] && data.reportList[index].reportId
      if (reportId) getSummaries(reportId)
    }
  }

  initNav = (index) => {
    this.setState({
      activeReportIndex: index,
      currentPage: Math.floor(index / 10) + 1,
    })
  }

  buttonClick = (template, id) =>
    window.open(
      `${config.backend}/pgs/reports/preview/${id}?templateId=${template}`
    )

  changeReport = (index, record) => {
    const {
      auth: { userInfo },
    } = this.props
    const { getSummaries } = this.props.store
    if (userInfo.roleType !== "research") {
      getSummaries(record.reportId)
    }
    this.refs.content.scrollTop = 0
    this.setState({
      activeReportIndex: index,
    })
    this.props.dataSwitch(index, record)
  }

  changePage = (e) => {
    let activeReportIndex = (e - 1) * 10
    let record = this.props.reportList[activeReportIndex]

    this.renderReportList(e)
    this.setState({
      currentPage: e,
      activeReportIndex,
    })
    this.changeReport(activeReportIndex, record)
  }

  renderSampleName = (reportList, currenNum) => {
    const { hospitalSampleName, sampleName } = reportList[currenNum]
    var sample=''
    if(hospitalSampleName){
       sample = hospitalSampleName +'  ('+ sampleName+')'
    }else{
       sample = sampleName
    }

    if (sample && sample.length > 23) {
      return (
        <Tooltip placement="left" title={sample}>
          {sample.slice(0, 23) + '...'}
        </Tooltip>
      )
    }
    return sample
  }

  renderReportList = (pageNumber) => {
    let { reportList } = this.props.data
    const {
      userInfo: { id },
    } = this.props.auth
    let { pushModalShowed } = this.state
    let reportListArr = []
    let endNum = pageNumber * 10

    if (endNum > reportList.length) {
      endNum = reportList.length
    }
    for (
      let currenNum = (pageNumber - 1) * 10;
      currenNum < endNum;
      currenNum++
    ) {
      const { state, reportState, stage } = reportList[currenNum]
      const liClass = cx({
        "report cursor-p": true,
        active: this.state.activeReportIndex === currenNum,
        disabled: pushModalShowed,
      })

      const sxClass = cx({
        "report cursor-p": true,
        active3:
          this.state.activeReportIndex === currenNum && reportState === "3",
        active2:
          this.state.activeReportIndex === currenNum && reportState === "2",
        active1:
          this.state.activeReportIndex === currenNum && reportState === "1",
        hover3: reportState === "3",
        hover2: reportState === "2",
        hover1: reportState === "1",
        disabled: pushModalShowed,
      })

      const angleClass = cx({
        "angle-top": true,
        angle3: reportState === "3",
        angle2: reportState === "2",
        angle1: reportState === "1",
      })

      if (state !== PREPARE_RUN && state !== RUNNING) {
        reportListArr.push(
          <li
            key={currenNum}
            onClick={() => {
              if (!pushModalShowed) {
                this.changeReport(currenNum, reportList[currenNum])
              }
            }}
            className={(id === "1007"||id === '179') ? sxClass : liClass}
          >
            {this.renderSampleName(reportList, currenNum)}
            {stage === 1 && (id === "1007" ||id === '179')&& (
              <span style={{ marginLeft: 5 }}>✰</span>
            )}
            {(id === "1007"||id === '179') && <span className={angleClass}></span>}
          </li>
        )
      }
    }
    return reportListArr
  }

  renderResultGender = (detailData) => {
    const {
      auth: { userInfo, pushAuth },
    } = this.props

    if (!pushAuth.showPgsGender) {
      return <li className="resultDetailText">XN</li>
    }
    if (
      detailData.resultGender !== "" &&
      detailData.resultGender !== "无法判断"
    ) {
      return (
        <li className="resultDetailText">
          {detailData.resultGender}
          {userInfo.id === "64" ||
          userInfo.id === "1007" ||
          userInfo.id === "1024" || 
          userInfo.id === "179" ? (
            <Icon
              className="minus-icon"
              type="minus-circle"
              onClick={() =>
                this.delReportResEle("resultGender", detailData.resultGender)
              }
            />
          ) : null}
        </li>
      )
    } else if (
      detailData.resultAneu !== "" &&
      detailData.resultAneu === "无法判断"
    ) {
      return <li className="resultDetailText">无法判断</li>
    } else {
      return <li className="resultDetailText">未见异常</li>
    }
  }

  renderResultAneu = (detailData) => {
    const userInfo = this.props.auth.userInfo
    if (detailData.resultAneu !== "" && detailData.resultAneu !== "无法判断") {
      const resultAneu = detailData.resultAneu.split(";").join("; ").split(" ")
      return resultAneu.map((item, index) => {
        if (item !== "") {
          return (
            <li key={index} className="resultDetailText">
              {item}
              {userInfo.id === "64" ||
              userInfo.id === "1007" ||
              userInfo.id === "1024" || 
              userInfo.id === "179" ? (
                <Icon
                  className="minus-icon"
                  type="minus-circle"
                  onClick={() => this.delReportResEle("resultAneu", item)}
                />
              ) : null}
            </li>
          )
        } else {
          return null
        }
      })
    } else if (
      detailData.resultAneu !== "" &&
      detailData.resultAneu === "无法判断"
    ) {
      return <li className="resultDetailText">无法判断</li>
    } else {
      return <li className="resultDetailText">未见异常</li>
    }
  }

  renderResultCNV = (detailData) => {
    const userInfo = this.props.auth.userInfo
    if (detailData.resultCNV !== "" && detailData.resultCNV !== "无法判断") {
      const resultCNV = detailData.resultCNV.split(";").join("; ").split(" ")
      return resultCNV.map((item, index) => {
        if (item !== "") {
          let isShowMark = Number(item.match(/\((\d+\.\d+)Mb\)/)[1]) < 4
          return (
            <li key={index} className="resultDetailText">
              {item}
              {userInfo.id === "64" ||
              userInfo.id === "1007" ||
              userInfo.id === "1024" || 
              userInfo.id === "179" ? (
                <Icon
                  className="minus-icon"
                  type="minus-circle"
                  onClick={() => this.delReportResEle("resultCNV", item)}
                />
              ) : null}

              {detailData.enableCnvGene && isShowMark && (
                <Popover
                  className="comment-popover"
                  content={this.renderResultComment(detailData, item)}
                  placement="right"
                  title="结果注释"
                >
                  <span className="result-comment">结果注释</span>
                </Popover>
              )}
            </li>
          )
        } else {
          return null
        }
      })
    } else if (
      detailData.resultAneu !== "" &&
      detailData.resultAneu === "无法判断"
    ) {
      return <li className="resultDetailText">无法判断</li>
    } else {
      return <li className="resultDetailText">未见异常</li>
    }
  }

  renderResultM = (detailData) => {
    if (
      detailData.resultM !== "" &&
      detailData.resultM !== undefined &&
      detailData.resultM !== null
    ) {
      return <li className="resultDetailText">{detailData.resultM}</li>
    } else {
      return ""
    }
  };

  renderResultMany = (detailData) => {
    if (
      detailData.ployStatistical !== "" &&
      detailData.ployStatistical !== undefined &&
      detailData.ployStatistical !== null &&
      (detailData.ployStatistical.Ploidy || detailData.ployStatistical.Zscore)
    ) {
      return (
        <li className="resultDetailText">
          {detailData.ployStatistical.Ploidy}
          {detailData.ployStatistical.Zscore!=='NA'?'('+detailData.ployStatistical.Zscore+')':''}
        </li>
      )
    } else {
      return <li className="resultDetailText">未见异常</li>
    }
  }

  renderResultROH = (detailData) => {
    if (
      detailData.rohStatistical !== "" &&
      detailData.rohStatistical !== undefined &&
      detailData.rohStatistical !== null &&
      detailData.rohStatistical.ROHResult
    ) {
      if (detailData.rohStatistical.ROHResult !== "无法判断") {
        const ROHResult = detailData.rohStatistical.ROHResult.split(";").join("; ").split(" ")
        return ROHResult.map((item, index) => {
          if (item !== "") {
            // if(item.indexOf('UPD')>0){
            //   return (
            //     <li key={index} className="resultDetailText Text-weight">
            //       {item}
            //     </li>
            //   )
            // }else{
              return (
                <li key={index} className="resultDetailText">
                  {item}
                </li>
              )
            // }
           
          } else {
            return null
          }
        })
      } else {
        return <li className="resultDetailText">无法判断</li>
      } 
    } else {
      return <li className="resultDetailText">未见异常</li>
    }
  }

  renderCommentGenes = (currentGene) => {
    return (
      <div>
        <div className="comment-title">Genes：</div>
        <div>
          <table>
            <thead>
              <tr>
                <th>Gene number</th>
                <th>Gene name</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{currentGene ? currentGene.geneNum : "-"}</td>
                <td>{currentGene ? currentGene.geneName : "-"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  renderCommentDeciphers = (currentDecipher) => {
    return (
      <div>
        <div className="comment-title">Decipher syndroms and genes：</div>
        <div>
          <table>
            <thead>
              <tr>
                <th>Syndroms</th>
                <th>Decipher gene| Tolerance of haploinsufficiency</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{currentDecipher ? currentDecipher.syndroms : "-"}</td>
                <td>{currentDecipher ? currentDecipher.gene : "-"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  renderCommentClinvars = (currentclinvar) => {
    return (
      <div>
        <div className="comment-title">
          ClinVar records of pathogenic and likely pathogenic CNV:
        </div>
        <div>
          <table>
            <thead>
              <tr>
                <th>ClinVar record</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{currentclinvar ? currentclinvar.record : "-"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  renderCommentxCnvHgmds = (currentCnvHgmd) => {
    return (
      <div>
        <div className="comment-title">HGMD genes：</div>
        <div>
          <table>
            <thead>
              <tr>
                <th>Gene number</th>
                <th>Gene name</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>{currentCnvHgmd ? currentCnvHgmd.geneNum : "-"}</td>
                <td>{currentCnvHgmd ? currentCnvHgmd.geneName : "-"} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  };

  renderCommentCnvOmim = (currentCnvOmim) => {
    return (
      <div>
        <div className="comment-title">OMIM disease：</div>
        <div>
          <table>
            <thead>
              <tr>
                <th>Genes</th>
                <th>OMIM disease</th>
              </tr>
            </thead>
            <tbody>
              {currentCnvOmim &&
                currentCnvOmim.omimDetailDTOS.map((omim, index) => {
                  return (
                    <tr key={index}>
                      <td>{omim.name || "-"}</td>
                      <td>{omim.disease || "-"}</td>
                    </tr>
                  )
                })}
              {!currentCnvOmim && (
                <tr>
                  <td colSpan="2">无</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  commonFilterFnc = (data, item) => {
    return data.filter((d) => d.cnv === item.split(";").shift())
  }

  renderResultComment = (detailData, item) => {
    const currentGene =
      detailData.cnvRefSeqGenes &&
      this.commonFilterFnc(detailData.cnvRefSeqGenes, item)
    const currentDecipher =
      detailData.cnvDeciphers &&
      this.commonFilterFnc(detailData.cnvDeciphers, item)
    const currentClinvar =
      detailData.cnvClinvars &&
      this.commonFilterFnc(detailData.cnvClinvars, item)
    const currentCnvOmim =
      detailData.cnvOmimDTOS &&
      this.commonFilterFnc(detailData.cnvOmimDTOS, item)
    const currentCnvHgmd =
      detailData.cnvHgmds && this.commonFilterFnc(detailData.cnvHgmds, item)
    return (
      <div className="reault-comment-wrap">
        <div className="comment-title">CNV：</div>
        <div>{item}</div>
        {this.renderCommentGenes(currentGene ? currentGene[0] : {})}
        {this.renderCommentDeciphers(currentDecipher ? currentDecipher[0] : {})}
        {this.renderCommentClinvars(currentClinvar ? currentClinvar[0] : {})}
        {this.renderCommentxCnvHgmds(currentCnvHgmd ? currentCnvHgmd[0] : {})}
        {this.renderCommentCnvOmim(currentCnvOmim ? currentCnvOmim[0] : {})}
      </div>
    )
  }

  getReportImageUrl = (reportId) => {
    const { detailData } = this.props
    const { getReportImageUrl } = this.props.store
    this.setState({
      exportModalShowed: true,
    })
    getReportImageUrl(detailData.reportId).then(
      (res) => {
        const exportDataUrl = res.url
        this.setState({
          exportModalShowed: false,
        })
        if (document.getElementById("export-a-tag"))
          document.getElementById("export-a-tag").outerHTML = ""
        let a = document.createElement("iframe")
        a.setAttribute("src", exportDataUrl)
        a.setAttribute("id", "export-a-tag")
        a.setAttribute("style", "display:none")
        //防止反复添加
        if (!document.getElementById("export-a-tag"))
          document.body.appendChild(a)
      },
      (err) => {
        message.error("下载失败，请您重试！")
        this.setState({
          exportModalShowed: false,
        })
      }
    )
  }

  changeSampleMark = (val) => {
    const { detailData } = this.props
    const { editTracer, getDetailData } = this.props.store
    editTracer({ sampleMark: val }, detailData.reportId).then(
      (res) => {
        message.success("标记成功")
        getDetailData(detailData.reportId)
      },
      (err) => {
        message.error(err.message)
      }
    )
  }

  addAneuploidy = (ele) => {
    let { detailData } = this.props
    detailData.resultAneu += ele + ";"
  }

  addReportResEle = (key, ele) => {
    let { detailData } = this.props
    key === "resultGender"
      ? (detailData[key] += ele + ";")
      : (detailData[key] += ele)
  }

  delReportResEle = (key, ele) => {
    this[key] = ele
    this.compareDelChecked(key)
  }

  compareDelChecked = (key) => {
    let { detailData } = this.props
    let deletedArr = this[key].split(";")
    let original = detailData[key].split(";")
    detailData[key] = this.delPushModalFunc(original, deletedArr)
  }

  delPushModalFunc = (original, deleted) => {
    original = original.filter((d) => d !== "")
    deleted = deleted.filter((d) => d !== "")
    for (let i = 0; i < deleted.length; i++) {
      for (let j = 0; j < original.length; j++) {
        if (original[j].trim() === deleted[i].trim()) {
          original.splice(j, 1)
          j--
        }
      }
    }
    return original.length !== 0 ? (original = original.join(";") + ";") : ""
  }

  delAllReportResCnv = () => {
    let { detailData } = this.props
    detailData.resultCNV = ""
  }

  addAllReportResCnv = () => {
    let { detailData } = this.props
    detailData.resultCNV = this.dumplicateCnv
  }

  delAllReportResEle = () => {
    let { detailData } = this.props
    let deleted = detailData.chromosomeRefinfos
      .map((info) => info.aneuploidy)
      .filter((f) => f !== undefined)
    let original = detailData.resultAneu.split(";")
    detailData.resultAneu = this.delPushModalFunc(original, deleted)
  }

  addAllReportResEle = () => {
    let { detailData } = this.props
    let infos = detailData.chromosomeRefinfos
    let additionArray = infos
      .map((info) => info.aneuploidy)
      .filter((f) => f !== undefined)
    let resultAneuArray =
      detailData.resultAneu.split(";").join(",").split(",") || []
    let concatArray = resultAneuArray.concat(additionArray)
    let uniquerArray = Array.from(new Set(concatArray)).filter((v) => v !== "")
    detailData.resultAneu = uniquerArray.join(",").split(",").join(";") + ";"
  }

  renderAppVersion = () => {
    let { detailData } = this.props
    if (
      detailData &&
      detailData.application &&
      detailData.application.appVersion
    ) {
      return <p>{detailData.application.appVersion}</p>
    }
    return "-"
  }

  @computed get isShowBtn() {
    let { detailData } = this.props
    let infos = detailData.chromosomeRefinfos
    if (infos) {
      let aneuploidyArr = infos
        .map((info) => info.aneuploidy)
        .filter((f) => f !== undefined)
      return aneuploidyArr.length > 0
    }
  }

  handleSyncSampleInfo = (reportId) => {
    const { syncSampleInfo, getDetailData } = this.props.store
    this.setState({ syncBtnLoading: true })
    syncSampleInfo(reportId).then(
      (res) => {
        message.success("同步成功")
        getDetailData(reportId)
        this.setState({ syncBtnLoading: false })
      },
      (err) => {
        this.setState({ syncBtnLoading: false })
        message.error(err.message)
      }
    )
  }

  render() {
    const {
      currentPage,
      pushModalShowed,
      editTracerShowed,
      compareModalShowed,
      syncBtnLoading,
    } = this.state
    let {
      data = {},
      detailData,
      templates,
      groupId,
      auth: { pushAuth = {}, userInfo },
    } = this.props
    let { summaries, summariesPlus, summariesAdvice } = this.props.store
    this.dumplicateCnv = detailData && detailData.resultCNVDumplicate
    let columnsData = []
    const columnsNewReport = [
      {
        title: "chromosome",
        dataIndex: "chromosome",
        width: 200,
        className: "ta-l",
      },
      {
        title: "Median",
        dataIndex: "average",
        width: 200,
        className: "ta-l",
      },
      {
        title: "Aneuploidy(mosaic)",
        dataIndex: "aneuploidy",
        className: "ta-l",
      },
    ]
    if (data.reportList === undefined) {
      data.reportList = []
    } else {
      if (!this.isEmptyObj(detailData) && detailData["statistical"]) {
        columnsData = [
          {
            title: "Total_Reads/Pairs",
            dataIndex: "Total_Reads",
            width: 130,
            className: "DataContent",
          },
          {
            title: "MT_ratio(%)",
            dataIndex: "MT_ratio(%)",
            width: 110,
            className: "DataContent",
          },
          {
            title: "Map_Ratio(%)",
            dataIndex: "Map_Ratio(%)",
            width: 110,
            className: "DataContent",
          },
          {
            title: "Duplicate(%)",
            dataIndex: "Duplicate(%)",
            width: 110,
            className: "DataContent",
          },
          {
            title: "Unique_Reads/Pairs",
            dataIndex: "Unique_Reads",
            width: 180,
            className: "DataContent",
            render: (text) => {
              return <div>{text || "-"}</div>
            },
          },
          {
            title: "GC_Count(%)",
            dataIndex: "GC_Count(%)",
            width: 110,
            className: "DataContent",
          },
          {
            title: "*SD",
            dataIndex: "*SD",
            width: 100,
            className: "DataContent",
          },
        ]
      }
    }
    if (
      userInfo &&
      (userInfo.id === "64" || 
        userInfo.id === "1007" || 
        userInfo.id === "1024" || 
        userInfo.id === "179")
    ) {
      columnsNewReport.push({
        title: (
          <div>
            操作
            {this.isShowBtn && (
              <span>
                <Icon
                  className="add-all-icon"
                  type="plus-circle"
                  onClick={() => this.addAllReportResEle()}
                />
                <Icon
                  className="minus-all-icon"
                  type="minus-circle"
                  onClick={() => this.delAllReportResEle()}
                />
              </span>
            )}
          </div>
        ),
        dataIndex: "oprator",
        width: 100,
        className: "ta-l",
        render: (text, record) => {
          const resultAneu = detailData.resultAneu.split(";")
          if (record.aneuploidy === undefined) {
            return null
          }
          return (
            <Row className="ta-l" type="flex" justify="" align="middle">
              {resultAneu.indexOf(record.aneuploidy) > -1 ? (
                <Icon
                  className="minus-table-icon"
                  type="minus-circle"
                  onClick={() =>
                    this.delReportResEle("resultAneu", record.aneuploidy)
                  }
                />
              ) : (
                <Icon
                  className="add-aneuploidy"
                  type="plus-circle"
                  style={{ color: "#286cac" }}
                  onClick={() => this.addAneuploidy(record.aneuploidy)}
                />
              )}
            </Row>
          )
        },
      })
    }
    return (
      <Row type="flex" className="pgs-report-detail">
        <div ref="content" className="content">
          <div id="detailTop" className="detail-card border-left-paimary first">
            <div className="pull-right">
              {templates !== undefined
                ? templates
                    .map((item) => {
                      if (
                        item.type === "data" &&
                        item.format === "html" &&
                        item.appGroupName === data.appGroupName
                      ) {
                        return (
                          <Button
                            key={item.id + "html"}
                            type="primary"
                            size="large"
                            onClick={(e) => {
                              this.buttonClick(item.id, detailData.reportId)
                            }}
                          >
                            <Icon type="book" />
                            打开报告
                          </Button>
                        )
                      } else if (
                        item.type === "data" &&
                        item.format === "pdf" &&
                        item.appGroupName === data.appGroupName
                      ) {
                        return (
                          <Button
                            key={item.id + "pdf"}
                            type="primary"
                            size="large"
                            onClick={(e) =>
                              this.buttonClick(item.id, detailData.reportId)
                            }
                          >
                            <Icon type="file-pdf" />
                            PDF 下载
                          </Button>
                        )
                      } else {
                        return ""
                      }
                    })
                    .filter((item) => item)
                : ""}
            </div>
            <div className="info-group">
              <label>数据类型：</label>
              <p>{data ? data.appName : ""}</p>
            </div>
            <div className="info-group">
              <label>文件名称：</label>
              <p>{!this.isEmptyObj(detailData) ? detailData.dataName : ""}</p>
            </div>
            <div className="info-group">
              <label>所在分组：</label>
              <p>{data.groupName || data.name}</p>
            </div>
            <div className="info-group">
              <label>样本名称：</label>
              <p>{!this.isEmptyObj(detailData) ? detailData.sampleName : []}</p>
            </div>
            <div className="info-group">
              <label>应用版本：</label>
              {this.renderAppVersion()}
            </div>
            {detailData.datas && (
              <div className="info-group tracer-wrapper">
                <label>标记分子：</label>
                <div>
                  {detailData.tracer
                    ? detailData.tracer.trim() === "NULL"
                      ? "-"
                      : detailData.tracer
                    : "-"}{" "}
                  |{" "}
                  <span className="write-tracer">
                    {detailData.datas[0].tracer
                      ? detailData.datas[0].tracer
                      : "-"}
                  </span>
                </div>
                <Button
                  onClick={() => this.showModal("editTracerShowed")}
                  className="edit-tracer-btn"
                  size="small"
                  type="primary"
                >
                  编辑
                </Button>
              </div>
            )}
            {detailData.tracerRemark && (
              <div className="info-group">
                <label>修改备注：</label>
                <p>
                  {!this.isEmptyObj(detailData) ? detailData.tracerRemark : ""}
                </p>
              </div>
            )}
            <div className="info-group">
              <label>检测项目：</label>
              <span>{detailData.project || "-"}</span>
              <Button
                loading={syncBtnLoading}
                onClick={() => this.handleSyncSampleInfo(detailData.reportId)}
                className="edit-tracer-btn"
                size="small"
                type="primary"
              >
                同步
              </Button>
            </div>
            <div className="info-group">
              <label>核型信息：</label>
              <span>{detailData.karyotype || "-"}</span>
            </div>
          </div>

          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">数据统计</h3>
            <Table
              columns={columnsData}
              rowKey={(record) => record.Total_Reads + "statistical"}
              dataSource={
                !this.isEmptyObj(detailData)
                  ? [].concat(detailData.statistical)
                  : []
              }
              pagination={false}
            />
          </div>
          {detailData.dataVersion === "v2.0" && (
            <div>
              {/* {userInfo.id !== '1015' && ( */}
                <div className="detail-card">
                  <h3 className="border-left-primary detail-card-title">
                    参考信息
                  </h3>
                  <Table
                    columns={columnsNewReport}
                    rowKey={(record) =>
                      record.average +
                      "" +
                      record.chromosome +
                      "" +
                      record.aneuploidy
                    }
                    dataSource={
                      !this.isEmptyObj(detailData)
                        ? detailData.chromosomeRefinfos.slice()
                        : []
                    }
                    pagination={false}
                  />
                </div>
              {/* )} */}
              <div className="detail-card">
                <div className="title-wrapper">
                  <h3 className="border-left-primary detail-card-title">
                    报告结果
                  </h3>
                  {detailData.status === 3 && (
                    <div>
                      <a
                        className="point-link"
                        onClick={() => this.showModal("compareModalShowed")}
                      >
                        报告结果对比
                      </a>
                    </div>
                  )}
                </div>

                <div className="reportResultWrap">
                  <ul>
                    <li>
                      <div className="reportResultTitle">
                        <span className="circle"></span>性染色体
                      </div>
                      <ul className="resultDetailList">
                        {this.renderResultGender(detailData)}
                      </ul>
                    </li>
                    <li>
                      <div className="reportResultTitle">
                        <span className="circle"></span>整倍体
                      </div>
                      <ul className="resultDetailList">
                        {this.renderResultAneu(detailData)}
                      </ul>
                    </li>
                    <li>
                      <div className="reportResultTitle">
                        <span className="circle"></span>
                        CNV
                        {detailData.resultCNVDumplicate !== "" &&
                          detailData.resultCNVDumplicate !== "无法判断" &&
                          detailData.resultCNVDumplicate !== null &&
                          detailData.resultCNVDumplicate !== undefined &&
                          (userInfo.id === "64" ||
                            userInfo.id === "1007" ||
                            userInfo.id === "1024" || 
                            userInfo.id === "179") && (
                            <div>
                              <Icon
                                className="add-all-icon"
                                type="plus-circle"
                                onClick={() => this.addAllReportResCnv()}
                              />
                              <Icon
                                className="minus-all-icon"
                                type="minus-circle"
                                onClick={() => this.delAllReportResCnv()}
                              />
                            </div>
                          )}
                      </div>
                      <ul className="resultDetailList">
                        {this.renderResultCNV(detailData)}
                      </ul>
                    </li>
                    <li>
                      <div className="reportResultTitle">
                        <span className="circle"></span>补充结果
                      </div>
                      <ul className="resultDetailList">
                        {this.renderResultM(detailData)}
                      </ul>
                    </li>
                    {detailData.application &&
                      ((data.appName).indexOf('plus') >-1) &&
                      (detailData.application.id === "143" ||
                        detailData.application.id === "144" ||
                        detailData.application.id === "147"||
                        detailData.application.id === "154"||
                        detailData.application.id === "155"||
                        detailData.application.id === "148" ) && (
                        <li>
                          <div className="reportResultTitle">
                            <span className="circle"></span>三倍体(异源)
                            { detailData.ployStatistical.Ploidy === '三倍体' &&(
                                  <Tooltip 
                                    overlayClassName='tooltipColor' 
                                    placement="right" 
                                    title='样本值大于3，疑似三倍体(异源)' 
                                    effect="light"
                                  >
                                    <img className="img-cursor-p" alt="" src={warningIcon} />
                                  </Tooltip>
                            )}
                          </div>
                          <ul className="resultDetailList">
                            {this.renderResultMany(detailData)}
                          </ul>
                        </li>
                      )}
                    {detailData.application &&
                      ((data.appName).indexOf('plus') >-1) &&
                      (detailData.application.id === "143" ||
                        detailData.application.id === "144" ||
                        detailData.application.id === "147" ||
                         detailData.application.id === "154"||
                         detailData.application.id === "155"||
                        detailData.application.id === "148") && (
                        <li>
                          <div className="reportResultTitle">
                            <span className="circle"></span>ROH
                            {detailData.rohStatistical.ROHResult && (
                                  <Tooltip 
                                    overlayClassName='tooltipColor' 
                                    placement="right" 
                                    title=''
                                    effect="light"
                                  >
                                    <img className="img-cursor-p" alt="" src={warningIcon} />
                                  </Tooltip>
                            )}
                          </div>
                          <ul className="resultDetailList">
                            {this.renderResultROH(detailData)}
                          </ul>
                        </li>
                      )}
                  </ul>
                </div>
              </div>
            </div>
          )}
          {detailData.dataVersion === "v1.0" && (
            <div>
              <div className="detail-card">
                <h3 className="border-left-primary detail-card-title">报告</h3>
                <Table
                  columns={columnsReport}
                  rowKey={(record) =>
                    record.average +
                    "" +
                    record.chromosome +
                    "" +
                    record.aneuploidy
                  }
                  dataSource={
                    !this.isEmptyObj(detailData) 
                    ? detailData.chromosomes 
                    : []
                  }
                  pagination={false}
                />
              </div>
              <div className="detail-card">
                <h3 className="border-left-primary detail-card-title">
                  补充信息
                </h3>
                <div>
                  <p>
                    {!this.isEmptyObj(detailData) ? detailData.resultM : "无"}
                  </p>
                </div>
              </div>
            </div>
          )}
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">染色体</h3>
            <ImageLightBox
              clickabled={false}
              imageSrc={
                !this.isEmptyObj(detailData)
                  ? !pushAuth.showPgsGender
                    ? detailData.imgNoXY.chromMiniPng
                    : detailData.imgWithXY.chromMiniPng
                  : []
              }
            />
            {/* <div>
              <img alt="" src={!this.isEmptyObj(detailData) ?
                (!pushAuth.showPgsGender ?
                  detailData.imgNoXY.chromMiniPng :
                  detailData.imgWithXY.chromMiniPng) :
                []}
              />
            </div> */}
          </div>
          <div className="detail-card">
            <div className="title-wrapper">
              <h3 className="border-left-primary detail-card-title">
                染色体点图
              </h3>
              <div>
                <Select
                  className="sample-mark"
                  defaultValue=""
                  onChange={this.changeSampleMark}
                  value={
                    detailData.sampleMark ? `${detailData.sampleMark}` : ""
                  }
                >
                  <Option value="" disabled>
                    请选择
                  </Option>
                  {/* <Option value="1">基线数据</Option>
                  <Option value="2">大片段</Option>
                  <Option value="3">小片段</Option>
                  <Option value="4">平衡易位</Option>  暂时注释保留*/}
                  <Option value="2">假阴性</Option>
                  <Option value="3">假阳性</Option>
                  <Option value="5">末端合并</Option>
                  <Option value="6">波动异常</Option>
                  <Option value="7">分段错误</Option>
                </Select>
                <a
                  onClick={this.getReportImageUrl}
                  className="point-link"
                  style={{ marginRight: 10, background: "#58bc00" }}
                >
                  下载染色体点图
                </a>
                <a
                  className="point-link"
                  href={`${config.backend}/pgs/reports/${
                    !this.isEmptyObj(detailData) && detailData.reportId
                  }/charts/gc?sampleName=${detailData.sampleName}`}
                  
                  target="_blank"
                >
                  精确染色体点图
                </a>
              </div>
            </div>
            <ImageLightBox
              imageSrc={
                !this.isEmptyObj(detailData)
                  ? !pushAuth.showPgsGender
                    ? detailData.imgNoXY.chromPointPng
                    : detailData.imgWithXY.chromPointPng
                  : []
              }
              mainSrc={
                !this.isEmptyObj(detailData)
                  ? !pushAuth.showPgsGender
                    ? detailData.imgNoXY.chromPointPng
                    : detailData.imgWithXY.chromPointPng
                  : []
              }
            />
            {(!this.isEmptyObj(detailData)&&  
              pushAuth.showPgsGender && 
              detailData.imgWithXY.chromPointSplitCnvPng) && (
                <div className="title-wrapper"  style={{ float: "right"}}>
                  <div >
                    <a
                      onClick={()=>{
                        this.setState({PointSplitCnvPngShow:!this.state.PointSplitCnvPngShow})
                      }}
                      className="point-link"
                      style={{ marginRight: 10 }}
                    >
                      
                      { this.state.PointSplitCnvPngShow?'返回':'CNV标注图'}
                    </a>
                  </div>
                </div>
            )}
            {this.state.PointSplitCnvPngShow?(
                  <ImageLightBox
                  imageSrc={
                    !this.isEmptyObj(detailData)
                      ? !pushAuth.showPgsGender
                        ? detailData.imgNoXY.chromPointSplitCnvPng
                        : detailData.imgWithXY.chromPointSplitCnvPng
                      : []
                  }
                  mainSrc={
                    !this.isEmptyObj(detailData)
                      ? !pushAuth.showPgsGender
                        ? detailData.imgNoXY.chromPointSplitCnvPng
                        : detailData.imgWithXY.chromPointSplitCnvPng
                      : []
                  }
                />
                ):(
                  <ImageLightBox
                    imageSrc={
                      !this.isEmptyObj(detailData)
                        ? !pushAuth.showPgsGender
                          ? detailData.imgNoXY.chromPointSplitPng
                          : detailData.imgWithXY.chromPointSplitPng
                        : []
                    }
                    mainSrc={
                      !this.isEmptyObj(detailData)
                        ? !pushAuth.showPgsGender
                          ? detailData.imgNoXY.chromPointSplitPng
                          : detailData.imgWithXY.chromPointSplitPng
                        : []
                    }
                  />
                )
            }
          </div>
          <div className="detail-card last">
            <h3 className="border-left-primary detail-card-title">
              染色体位置图
            </h3>
            <ImageLightBox
              clickabled={false}
              imageSrc={
                !this.isEmptyObj(detailData)
                  ? !pushAuth.showPgsGender
                    ? detailData.imgNoXY.chromFinalPng
                    : detailData.imgWithXY.chromFinalPng
                  : []
              }
            />
          </div>
          {detailData.application &&
            ((data.appName).indexOf('plus') >-1) &&
            (detailData.application.id === "143" ||
              detailData.application.id === "144" ||
              detailData.application.id === "147" ||
               detailData.application.id === "154"||
               detailData.application.id === "155"||
              detailData.application.id === "148" ) && (
              <div className="detail-card">
                <div className="title-wrapper">
                  <h3 className="border-left-primary detail-card-title">
                    染色体杂合率图
                  </h3>
                  <div>
                    <a
                      className="point-link"
                      href={`${config.backend}/pgs/reports/${
                        !this.isEmptyObj(detailData) && detailData.reportId
                      }/charts/gcPlus?sampleName=${detailData.sampleName}`}
                      target="_blank"
                    >
                      精确染色体杂合率图
                    </a>
                  </div>
                </div>
                <ImageLightBox
                  imageSrc={
                    !this.isEmptyObj(detailData) && detailData.imgForHetRatio
                      ? detailData.imgForHetRatio.hetRatioPng
                      : []
                  }
                  mainSrc={
                    !this.isEmptyObj(detailData) && detailData.imgForHetRatio
                      ? detailData.imgForHetRatio.hetRatioPng
                      : []
                  }
                />
              </div>
            )}
          {detailData.application &&
            ((data.appName).indexOf('plus') >-1) &&
            (detailData.application.id === "143" ||
              detailData.application.id === "144" ||
              detailData.application.id === "147" ||
               detailData.application.id === "154"||
               detailData.application.id === "155"||
              detailData.application.id === "148") && (
              <div className="detail-card last">
                <h3 className="border-left-primary detail-card-title">
                  倍性分析图
                </h3>
                <ImageLightBox
                  imageSrc={
                    !this.isEmptyObj(detailData) && detailData.imgForLikelihood
                      ? detailData.imgForLikelihood.likelihoodPng
                      : []
                  }
                  mainSrc={
                    !this.isEmptyObj(detailData) && detailData.imgForLikelihood
                      ? detailData.imgForLikelihood.likelihoodPng
                      : []
                  }
                />
              </div>
            )}

            {detailData.application && 
              ((data.appName).indexOf('plus') >-1) &&
              (detailData.application.id === "143" ||
              detailData.application.id === "144" ||
              detailData.application.id === "147" ||
               detailData.application.id === "154"||
               detailData.application.id === "155"||
              detailData.application.id === "148" ) && ( 
              <div className="detail-card last">
                <h3 className="border-left-primary detail-card-title">
                  倍性分析窗口图
                </h3>
                <ImageLightBox
                  imageSrc={
                    !this.isEmptyObj(detailData) && detailData.imgForLikelihood
                      ? detailData.imgForLikelihood.likelihoodWindowPng
                      : []
                  }
                  mainSrc={
                    !this.isEmptyObj(detailData) && detailData.imgForLikelihood
                      ? detailData.imgForLikelihood.likelihoodWindowPng
                      : []
                  }
                />
              </div>
            )}
          <div className="wrapper-download">
            <a
              href={`${config.backend}/pgs/reports/${
                !this.isEmptyObj(detailData) && detailData.reportId
              }/download`}
              title="下载报告"
              className="download"
            >
              <img src={downloadIcon} alt="下载" />
            </a>
          </div>

          {pushAuth.notifyLimsPgs && (
            <div className="wrapper-push">
              <a
                onClick={() => this.showModal("pushModalShowed")}
                title="推送报告"
                className="push"
              >
                <img src={pushIcon} alt="推送" />
              </a>
            </div>
          )}
         
        </div>
        <div className="reportNav">
          <div className="title">本组数据</div>
          <ul className="reports">{this.renderReportList(currentPage)}</ul>
          <Pagination
            className="pagination"
            size="small"
            pageSize={10}
            total={
              data.reportList.filter(
                (item) => item.state !== PREPARE_RUN && item.state !== RUNNING
              ).length
            }
            current={currentPage}
            onChange={(e) => {
              if (!pushModalShowed) {
                this.changePage(e)
              }
            }}
          />
        </div>

        {/* {true && ( */}
        {pushModalShowed && (
          <PushModal
            store={this.props.store}
            data={data}
            summaries={summaries}
            summariesPlus={summariesPlus}
            summariesAdvice={summariesAdvice}
            closeModal={() => this.closeModal("pushModalShowed")}
            groupId={groupId}
          />
        )}
       
        {editTracerShowed && (
          <EditTracerModal
            store={this.props.store}
            detailData={detailData}
            closeModal={this.closeModal}
          />
        )}
        {compareModalShowed && (
          <CompareModal
            store={this.props.store}
            detailData={detailData}
            data={data}
            closeModal={this.closeModal}
          />
        )}
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/ReportDetail/index.js